// What a FontAwesome icon says to assistive technology, as its JS mode used to
// set it on the <svg> it generated: a titled icon is an image named by its
// title, an untitled one is decoration and hidden. Under the webfont CSS
// (SHO-TSK-1434) the icon stays the element we render, so it says so itself.
const iconA11y = (title?: string | null) =>
  title ? { title, role: "img", "aria-label": title } : { "aria-hidden": true }

export default iconA11y
